import type { WeekHours } from '../types';

const defaultDay = { open: true, from: '09:00', to: '21:00' };
const weekendDay = { open: true, from: '10:00', to: '22:00' };
const closedDay = { open: false, from: '09:00', to: '21:00' };

export const DEFAULT_WEEK_HOURS: WeekHours = {
  mon: defaultDay,
  tue: defaultDay,
  wed: defaultDay,
  thu: defaultDay,
  fri: defaultDay,
  sat: weekendDay,
  sun: closedDay,
};
